// extracted by mini-css-extract-plugin
var _1 = "ProfileGradeChanger__arrow--AmhRb";
var _2 = "ProfileGradeChanger__arrowOuter--dUuHj";
var _3 = "ProfileGradeChanger__hidden--nay_K";
var _4 = "ProfileGradeChanger__icon--ZXruH";
var _5 = "ProfileGradeChanger__iconOuter--c4TBm";
var _6 = "ProfileGradeChanger__main--ArzmY";
export { _1 as "arrow", _2 as "arrowOuter", _3 as "hidden", _4 as "icon", _5 as "iconOuter", _6 as "main" }
